module.exports = __webpack_public_path__ + "static/media/tiles-footer-left.e34767eb.svg";